import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import axios from "../../fetch-api/fetch-api";

export function getRecentlyViewedProductsApi() {
  return axios.post<Array<ICompactProduct>>("/get-recently-viewed-products-v3");
}
